
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'
import { useRoute } from 'vue-router'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisations
import { billing } from '@/core/realisations/billing.realisation'

// types
import { CalculationT } from '@/core/types/billing.types'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    name: 'InvoiceCalculation',
    components: {
        'page-title': PageTitle,
        'failed-fetch': FailedFetch,
        loader: Loader,
        'the-button': TheButton,
    },
    setup() {
        const route = useRoute()
        const calculation_id = Number(route.params.calculation_id as string)

        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            calculation: null as CalculationT | null,
        })

        const loadCalculation = async () => {
            try {
                state.is_loading = true

                const response = await billing.getCalculation(calculation_id)
                state.calculation = response.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true

                notifications.notifyError({
                    error,
                    title: 'При получении вычисления произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadCalculation)

        const isAllAdditionalServicesEmpty = computed(() => {
            if (!state.calculation) return true

            if (
                !state.calculation.additionalServiceValue.craneCost &&
                !state.calculation.additionalServiceValue.gridCost &&
                !state.calculation.additionalServiceValue.hydraulicTrolleyCost &&
                !state.calculation.additionalServiceValue.loaderCost &&
                !state.calculation.additionalServiceValue.manipulatorCost &&
                !state.calculation.additionalServiceValue.palletCost &&
                !state.calculation.additionalServiceValue.softPackageCost
            ) {
                return true
            }

            return false
        })

        return { calculation_id, state, loadCalculation, isAllAdditionalServicesEmpty }
    },
})
